export default __webpack_public_path__ + "static/media/metamask.eaace09e.svg";